<template>

    <FloatingPanel :title="title" :width="calculatedWidth">

        <div class="common-canvas-editor-canvas-document-editors-loop-owlCarousel-LoopItemPanel">

            <slot />

            <div class="tw-px-5 tw-py-3 text">

                <div class="tw-text-gray-600 label">Positie van slide</div>
                <small class="tw-block tw-mb-3 tw-text-gray-500 label tw-text-muted">Bepaal in welke volgorde deze slide in de slider getoond wordt.</small>

                <div class="tw-flex tw-mt-1">

                    <button
                        :class="'tw-bg-blue-500 tw-px-3 tw-py-1 tw-inline-block tw-text-white tw-rounded ' + (loopIndex == 0 ? 'tw-opacity-50' : '')"
                        :disabled="loopIndex == 0"
                        @click="mutateIndex(-1)">
                        <i class="fa fa-arrow-left tw-mr-1"></i>
                        Verplaats terug
                    </button>

                    <button
                        :class="'tw-bg-blue-500 tw-px-3 tw-py-1 tw-inline-block tw-text-white tw-rounded tw-ml-3 ' + (loopIndex == loopItems.length - 1 ? 'tw-opacity-50' : '')"
                        :disabled="loopIndex == loopItems.length - 1"
                        @click="mutateIndex(1)">
                        Verplaats verder
                        <i class="fa fa-arrow-right tw-ml-1"></i>
                    </button>

                </div>

            </div>

            <div class="tw-px-5 tw-pt-3 text">

                <!-- @ugly Use of negative margin. -->
                <div class="tw--mb-2 tw-text-gray-600 label">Acties</div>

            </div>

        </div>

        <span slot="actionsExtra">

            <button
                    class="tw-text-sm tw-bg-red-500 tw-text-white tw-rounded tw-px-3 tw-py-2 tw-mr-4 focus:tw-bg-red-600 hover:tw-bg-red-400"
                    @click="removeItem">
                <i class="fa fa-trash mr-1"></i> Verwijder
            </button>

        </span>

    </FloatingPanel>

</template>

<script>

    import LoopItemPanel from "../LoopItemPanel";
    import FloatingPanel from "../../panels/FloatingPanel";

    export default {

        extends: LoopItemPanel,

        components: {
            FloatingPanel,
        },

		props: {
			title: {
				type: String,
				default()
				{
					// @ugly Getting the editor this way and get the label.
					return this.$parent.selection.currentSelection.editableData?.label || 'Slide';
				},
			},
			width: Number,
		},

        methods: {

			mutateIndex(mutation)
            {
            	// Get original data.
                let originals = {
                	loopIndex2canvasBlocks: {},
                    loopItems: [...this.loopItems],
				};

                // Fill original canvas blocks map.
				for(let child of this.loopEditorComponent.$children)
					originals.loopIndex2canvasBlocks[child.loopIndex] = child.canvasBlocks;

				// Determine index to swap with.
				let swapWithIndex = this.loopIndex + mutation;

				if(swapWithIndex < 0)
					swapWithIndex = this.loopItems.length - 1;

				else if(swapWithIndex > this.loopItems.length - 1)
				    swapWithIndex = 0;

                // Update indices.
                for(let swap of [
                	[swapWithIndex, this.loopIndex],
                    [this.loopIndex, swapWithIndex]
                ])
                {
                    // Swap canvas blocks.
                    for(let canvasBlock of originals.loopIndex2canvasBlocks[swap[0]])
                    {
                        // Determine key suffix (after "loop.x")
                        let keySuffix = canvasBlock.key.split('.').slice(2).join('.');

                        // Set new key.
                        this.$set(canvasBlock, 'key', this.loopKey + '.' + swap[1] + '.' + keySuffix);
                    }

                    // Set in loop items.
					this.$set(this.loopItems, swap[0], originals.loopItems[swap[1]]);
                }
            },

        },

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-editor-canvas-document-editors-loop-owlCarousel-LoopItemPanel {

        @import './../../../../../../../../../sass/common/canvas/editor/canvas/document/adminTemplate';

        .actions:first-child {
            @apply tw-pt-3;
        }

    }

</style>